import consumer from "./consumer"

const userSignedIn = document.querySelector('meta[name="user-signed-in"]')?.content === 'true';

if (userSignedIn) {
  consumer.subscriptions.create("NotificationsChannel", {
    connected() {
      // Called when the subscription is ready for use on the server
    },

    disconnected() {
      // Called when the subscription has been terminated by the server
    },

    received(data) {
      // Update all unread badges
      const unreadBadges = document.querySelectorAll("[data-notifications-unread-badge], [id^='unread-count']");
      unreadBadges.forEach(badge => {
        badge.textContent = data.unread_count;
        if (data.unread_count > 0) {
          badge.classList.remove("hidden");
        } else {
          badge.classList.add("hidden");
        }
      });

      const notificationsList = document.getElementById("notifications-list");
      if (notificationsList) {
        const notification = data.notification;
        const html = `
          <a href="${notification.target_path}" class="block px-6 py-4 hover:bg-gray-50 transition border-b border-gray-50 last:border-0 bg-blue-50/50">
            <p class="text-xs text-gray-800 font-medium leading-relaxed">${notification.content}</p>
            <p class="text-[10px] text-gray-400 font-bold mt-1 uppercase">Just now</p>
          </a>
        `;
        notificationsList.insertAdjacentHTML('afterbegin', html);
        
        // Remove "No notifications yet" message if it exists
        const emptyMessage = notificationsList.querySelector('.text-center');
        if (emptyMessage) {
          emptyMessage.remove();
        }
      }
    }
  });
}
